document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.getElementById('selector-cantidad');
  const btnUnidad = document.getElementById('variant-unity');
  const btnCaja = document.getElementById('variant-box');
  const addToCartBtn = document.getElementById('normalAddToCartBtn');
  const addAndGoCheckout = document.getElementById('addAndGoCheckout');
  const quantityInput = document.getElementById('product-quantity-input');
  const variantsContent = document.getElementById('variants-content');

  const priceContainer = document.querySelector('.price__sale');
  const unitsPerBox = Number(btnCaja?.dataset.unitsPerBox) || 0;

  let isBox = false;
  let selfUpdate = false; // evita bucle cuando nosotros escribimos el precio

  // ---- Helpers de precio (CLP) ----
  function parseCLP(text) {
    const n = Number(String(text).replace(/[^\d]/g, ''));
    return Number.isFinite(n) ? n : 0;
  }
  function formatCLP(num) {
    return '$' + Math.round(num).toLocaleString('es-CL');
  }
  function priceEls() {
    return {
      sale: document.getElementById('product-price'),
      compare: document.getElementById('product-price-compare'),
    };
  }
  // Guarda el precio UNITARIO (lo que renderiza el tema) como base de cálculo
  function captureBase() {
    const { sale, compare } = priceEls();
    if (sale) sale.dataset.base = parseCLP(sale.textContent);
    if (compare && compare.textContent.trim()) {
      compare.dataset.base = parseCLP(compare.textContent);
    }
  }
  // Escribe el precio según el modo actual (unidad o caja)
  function renderPrice() {
    const { sale, compare } = priceEls();
    const factor = isBox && unitsPerBox > 0 ? unitsPerBox : 1;
    selfUpdate = true;
    if (sale && sale.dataset.base != null) {
      sale.textContent = formatCLP(Number(sale.dataset.base) * factor);
    }
    if (compare && compare.dataset.base != null) {
      compare.textContent = formatCLP(Number(compare.dataset.base) * factor);
    }
    // liberamos el guard después del batch del observer
    requestAnimationFrame(() => { selfUpdate = false; });
  }

  function setMode(mode) {
    const isBoxSelected = mode === 'caja';
    isBox = isBoxSelected;

    btnUnidad.classList.toggle('active', !isBoxSelected);
    btnCaja.classList.toggle('active', isBoxSelected);

    addToCartBtn?.setAttribute('data-is-box', isBoxSelected);
    addAndGoCheckout?.setAttribute('data-is-box', isBoxSelected);

    addToCartBtn?.setAttribute('data-product-quantity', '1');
    addAndGoCheckout?.setAttribute('data-product-quantity', '1');
    if (quantityInput) quantityInput.value = '1';

    renderPrice(); // <- actualiza el precio al cambiar de formato
  }

  function getActiveVariantQty() {
    const el = document.querySelector('#variants-content input.active');
    if (!el) return null;
    const qty = Number(el.dataset.variantQuantity);
    return Number.isFinite(qty) ? qty : null;
  }

  function getActiveVariantName() {
    const el = document.querySelector('#variants-content input.active');
    if (!el) return null;
    return el.value;
  }

  function disableCaja() {
    btnCaja.disabled = true;
    btnCaja.setAttribute('aria-disabled', 'true');
    btnCaja.classList.add('disabled');
    if (btnCaja.classList.contains('active')) setMode('unidad');
  }

  function enableCaja() {
    btnCaja.disabled = false;
    btnCaja.removeAttribute('aria-disabled');
    btnCaja.classList.remove('disabled');
  }

  function updateCajaState() {
    const variantQty = getActiveVariantQty();
    if (variantQty == null || unitsPerBox <= 0) {
      enableCaja();
      return;
    }
    if (variantQty < unitsPerBox) {
      disableCaja();
    } else {
      enableCaja();
    }
  }

  // Clicks en los botones de formato
  toggle.addEventListener('click', function (e) {
    const target = e.target.closest('button');
    if (!target) return;
    if (target === btnCaja && btnCaja.disabled) return;
    const mode = target.dataset.value === 'caja' ? 'caja' : 'unidad';
    [...toggle.querySelectorAll('button')].forEach(b => b.classList.remove('active'));
    setMode(mode);
  });

  btnCaja.addEventListener('click', function (e) {
    let variantName = getActiveVariantName() + "-CAJA"

    let newProductImgs = document.querySelectorAll(".product-image-variant");
    let newSliderImgs = document.querySelectorAll(".slider-image-variant");
    let addedActive = false;
    newProductImgs.forEach((img, i) => {
      img.classList.add("d-none");
      img.classList.remove("active-variant");
      img.classList.remove("active");
      newSliderImgs[i].classList.add("d-none");
      newSliderImgs[i].classList.remove("active-variant");
      newSliderImgs[i].classList.remove("active");

      let alt = img.querySelector("img").alt;
      if (alt === variantName) {
        img.classList.remove("d-none");
        img.classList.add("active-variant");
        newSliderImgs[i].classList.remove("d-none");
        newSliderImgs[i].classList.add("active-variant");
        if (!addedActive) {
          newSliderImgs[i].classList.add("active");
          addedActive = true;
        }
      }
    })
  })

  btnUnidad.addEventListener('click', function (e) {
    let variantName = getActiveVariantName()

    let newProductImgs = document.querySelectorAll(".product-image-variant");
    let newSliderImgs = document.querySelectorAll(".slider-image-variant");
    let addedActive = false;
    newProductImgs.forEach((img, i) => {
      img.classList.add("d-none");
      img.classList.remove("active-variant");
      img.classList.remove("active");
      newSliderImgs[i].classList.add("d-none");
      newSliderImgs[i].classList.remove("active-variant");
      newSliderImgs[i].classList.remove("active");

      let alt = img.querySelector("img").alt;
      if (alt === variantName) {
        img.classList.remove("d-none");
        img.classList.add("active-variant");
        newSliderImgs[i].classList.remove("d-none");
        newSliderImgs[i].classList.add("active-variant");
        if (!addedActive) {
          newSliderImgs[i].classList.add("active");
          addedActive = true;
        }
      }
    })
  })

  // Reaccionar a cambios de variante (stock -> habilitar/deshabilitar caja)
  if (variantsContent) {
    variantsContent.addEventListener('click', updateCajaState, true);
    variantsContent.addEventListener('change', updateCajaState, true);
    const mo = new MutationObserver(updateCajaState);
    mo.observe(variantsContent, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  // Cuando el tema actualiza el precio (cambio de SABOR), re-capturamos la base
  // y volvemos a aplicar el modo actual (unidad/caja).
  if (priceContainer) {
    const priceObserver = new MutationObserver(function () {
      if (selfUpdate) return; // el cambio lo hicimos nosotros -> ignorar
      captureBase();
      renderPrice();
    });
    priceObserver.observe(priceContainer, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  // Inicial
  captureBase();      // guarda el precio unitario base
  setMode('unidad');
  updateCajaState();
});